import * as React from 'react'

export const HorizontalRule = () =>
	<div className="sbHorizontalRule"></div>


// WEBPACK FOOTER //
// ./src/lib/sbhtml/horizontal-rule.tsx